import { render } from "./SignaturePad.vue?vue&type=template&id=24689e1f"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
script.render = render

export default script